import React from 'react';
import PropTypes from 'prop-types';

const DeleteIcon = ({ width = 18, height = 18, color = '#505680', className = '' }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 16 18" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{
        opacity: 1,
        transform: 'rotate(0deg)',
        display: 'block'
      }}
    >
      <path 
        d="M3 18C2.45 18 1.97917 17.8042 1.5875 17.4125C1.19583 17.0208 1 16.55 1 16V3H0V1H5V0H11V1H16V3H15V16C15 16.55 14.8042 17.0208 14.4125 17.4125C14.0208 17.8042 13.55 18 13 18H3ZM5 14H7V5H5V14ZM9 14H11V5H9V14Z" 
        fill={color}
      />
    </svg>
  );
};

DeleteIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  className: PropTypes.string
};

export default DeleteIcon; 